import { Table, type TableProps } from "@mantine/core";
import React from "react";

import styles from "./Logbook.module.scss";

export const StyledPreTextTable: React.FC<TableProps> = ({
  className,
  ...props
}) => (
  <Table
    className={`${styles.styledPreTextTable} ${className ?? ""}`}
    {...props}
  />
);

export const ReadonlyFieldset: React.FC<
  React.FieldsetHTMLAttributes<HTMLFieldSetElement>
> = ({ children, className, ...rest }) => (
  <fieldset className={`${styles.readonlyFieldset} ${className ?? ""}`} {...rest}>
    {children}
  </fieldset>
);
